export var selectTooltipSettings = state => state.tooltip.settings;